import React, { Component } from 'react'
import PieChart from "./PieChart"

import "./LineGraph.css";

export default class ConsumedPieChart extends Component {
  distinctUnits (arrData) {
    return arrData.filter((x, index, self) => self.findIndex(y => y?.units1 === x?.units1) === index)
  }

  propsToChart() {
    return this.props.report.map(i => Math.abs(i.Consumed1))
  }
  getLabels () {
    console.log (this.props)
    return this.props.report.map(i=> "Bldg "+i.Building+", Apt "+i.Apt)
  }
  render() {
    return (
      <div className='piechartContainer'>
        {this.props?.report ?
          <PieChart labels={this.getLabels()} units={this.props.report[0].units1}
            data={this.propsToChart()}/>
          : null}
        Relative {this.props?.report[0].units1} consumption
      </div>
    )
  }
}
